import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const fetchBusinessGroupsTypes = getApiActionTypes('FETCH_BUSINESS_GROUP');
export const updateBusinessGroupsTypes = getApiActionTypes('UPDATE_BUSINESS_GROUP');
export const deleteBusinessGroupsTypes = getApiActionTypes('DELETE_BUSINESS_GROUP');
export const createBusinessGroupsTypes = getApiActionTypes('CREATE_BUSINESS_GROUP');
